<!-- 公众服务页面 -->
<template>
  <div class="office-hall">
    <div class="mytab">
      <div class="tag">在线服务</div>
    </div>
    <div class="service flex">
      <div
        v-for="(guide, gIndex) in grouping1"
        :key="gIndex"
        class="guide flex-center hover-inter-active"
        @click="handleGuideClick(guide, 1)"
        :class="{ 'my-guide': gIndex == 1 }"
      >
        {{ guide.tag }}
      </div>
    </div>
    <div class="office-card">
      <div class="mytab">
        <span class="tag">办事指南</span>
      </div>
      <div class="service flex">
        <div
          v-for="(guide, gIndex) in tabItem.grouping2.filter(item => item.tag !== '承检能力')"
          :key="gIndex"
          class="guide flex-center hover-inter-active"
          @click="handleGuideClick(guide, 0)"
        >
          {{ guide.tag }}
        </div>
      </div>
    </div>

    <!--轮播图-->
    <div class="carousel-tab pc-comp">
      <news-tab
        @getCurrentTab="getCurrentTab"
        :methodsIncluding="'hover'"
      ></news-tab>
      <div class="slideshow" v-if="activeName !== '检验能力'">
        <el-carousel
          height="580px"
          autoplay
          :interval="3000"
          loop
          arrow="never"
          :indicator-position="
            carouselImages && carouselImages.length > 1 ? 'outside' : 'none'
          "
        >
          <el-carousel-item v-for="(imgsitem, i) in carouselImages" :key="i">
            <div class="carousel-image-box">
              <el-image
                style="width: 100%; height: auto"
                :src="path + imgsitem.path"
                :preview-src-list="[path + imgsitem.path]"
              >
              </el-image>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="testing-ability" v-else>
        <div class="flex content">
          <div class="left">
            <div
              v-for="(item, i) in testingData"
              :key="i"
              @mouseover="onTestingName(item, i)"
              class="left-title flex-center"
              :class="isActiveI == i ? 'is-active' : ''"
            >
              <span class=""> {{ item.testingName }}</span>
            </div>
          </div>
          <div class="right">
            <ul class="news-ul-li" style="height: 420px">
              <li
                class="space-between"
                v-for="(item, i) in listData"
                :key="i"
                @click="
                  toDetails(
                    {
                      id: item.id,
                      title: '公众服务',
                      tag: '检验能力'
                    },
                    item.linkTo
                  )
                "
              >
                <p class="text_overflow" :title="item.title">{{ item.title }}</p>
                <span>{{
                  item.publishedDate
                    ? item.publishedDate.split(' ')[0]
                    : item.createdDate.split(' ')[0]
                }}</span>
              </li>
            </ul>
            <div class="pagination" style="justify-content: center">
              <el-pagination
                 @size-change="(val) => handlePagination('size', val)"
                 @current-change="(val) => handlePagination('page', val)"
                :current-page="params.page"
                :page-sizes="[10, 20, 50, 60]"
                :page-size="params.size"
                layout="total, sizes, prev, slot, pager, next, jumper"
                :total="total"
                background
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="carousel-tab mobile-comp">
      <template>
        <div
          v-for="(item, i) in imgdataObj"
          :key="i"
          class="carousel-box"
          :id="item.hash"
        >
          <div class="mytab">
            <div class="tag">{{ item.tag }}</div>
          </div>
          <template v-if="item.tag !== '检验能力'">
            <img
              v-for="(imgItem, imgI) in item.attachmentList || carouselImages"
              :key="imgI"
              :src="path + imgItem.path"
              :alt="imgItem.name"
              class="carousel-image"
            />
          </template>
          <div v-else class="doc-box">
            <el-collapse v-model="activeNames" class="mobile-collapse">
              <el-collapse-item
                v-for="(item, i) in testingData"
                :key="i"
                :title="item.testingName"
                :name="i"
              >
              <div v-if="activeNames.includes(i)">
                <ul class="news-ul-li" style="height: 420px">
                  <li
                    class="space-between"
                    v-for="(article, j) in mobileListData[i] || []"
                    :key="j"
                    @click="
                      toDetails(
                        {
                          id: article.id,
                          title: '公众服务',
                          tag: '检验能力'
                        },
                        article.linkTo
                      )
                    "
                  >
                    <p class="text_overflow" :title="item.title">
                      {{ article.title }}
                    </p>
                    <span>{{
                      article.publishedDate
                        ? article.publishedDate.split(' ')[0]
                        : article.createdDate.split(' ')[0]
                    }}</span>
                  </li>
                </ul>
                <div class="pagination" style="justify-content: center">
                  <el-pagination
                    @size-change="(val) => handlePagination('size', val, i)"
                    @current-change="(val) => handlePagination('page', val, i)"
                    :current-page="mobileParams[i] && mobileParams[i].page || 0"
                    :page-sizes="[10, 20, 50, 60]"
                    :page-size="mobileParams[i] && mobileParams[i].size || 10"
                    layout="total, sizes, prev, slot, pager, next, jumper"
                    :total="mobileTotal[i] || 0"
                    background
                  >
                    <span class="slot">
                      {{ (mobileParams[i] && mobileParams[i].page || 0) + 1 }}/{{ Math.ceil((mobileTotal[i] || 0) / 15) }}
                    </span>
                  </el-pagination>
                </div>
              </div>
               
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import newsTab from '../../components/news/news-tab.vue'
import { mapState } from 'vuex'
import { getArticleDetails, getArticleList, getKey } from '@/api/index'

export default {
  name: 'officeHall',
  props: [],
  components: { newsTab },
  data() {
    return {
      grouping1: [
        {
          tag: '客户服务平台',
          url: 'http://116.252.25.141:8901/workspaces'
        },
        {
          tag: '大型仪器设备共享平台',
          url: 'http://222.216.37.168:8086/mylims/resource/sunway/dxyqgx.jsp?url=/mylims/'
        }
      ],
      carouselImages: [],
      imgdataObj: [],
      // 质量方针的tab
      activeName: '',
      listData: [],
      testingData: [],
      params: {
        page: 0,
        size: 10
      },
      total: 0,
      isActiveI: 0,
      activeNames: [0],
      // 移动端每个分类的数据
      mobileListData: {},
      // 移动端每个分类的分页参数
      mobileParams: {},
      // 移动端每个分类的总数
      mobileTotal: {},
      // 区分PC端和移动端 
      isMobile: false,
    }
  },
  watch: {
    '$route.hash': {
      handler(val) {
        if (val) {
          this.scrollToAnchor(val.slice(1))
        }
      }
    },
    activeNames: {
      handler(newVal) {
        if (!this.testingData || this.testingData.length === 0) return;
        
        newVal.forEach(index => {
          if (this.testingData[index] && !this.mobileListData[index]) {
            this.getArticleList(this.testingData[index].key, index)
          }
        })
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(['tabItem'])
  },
  mounted() {
  },
  methods: {
     // 点击检验能力分类
     onTestingName(item, i) {
      this.isActiveI = i
      this.getArticleList(item.key)
    },
    handleGuideClick(guide, type) {
      if (type) {
        window.open(guide.url, '_blank')
      } else {
        this.$router.push({
          path: '/document',
          query: { title: '公众服务', tag: guide.tag, key: guide.key }
        })
        this.$store.commit('SET_TABS', {
          children: this.tabItem.children
        })
      }
    },
    getCurrentTab(activeName) {
      this.activeName = activeName
      this.imgdataObj.forEach((item) => {
        if (activeName == item.tag) {
          this.carouselImages = item.attachmentList
        }
      })
    },
    async getArticleDetails() {
      if (this.$route.query.key) {
        getArticleDetails(this.$route.query.key).then((res) => {
          this.carouselImages = res.attachmentList
        })
      }
      this.imgdataObj = [...this.tabItem.children]
      await this.imgdataObj.forEach((item) => {
        if (item.key) {
          getArticleDetails(item.key).then((res) => {
            item['attachmentList'] = res.attachmentList
          })
        }
      })
    },
    scrollToAnchor(id) {
      this.$nextTick(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ block: 'center' })
        }
      })
    },
    // 获取检验能力的分类
    getTestingData() {
      const key = 'testing-ability'
        getKey({ key: key }).then(res => {
          if (res && res.children) {
            this.testingData = res.children.map(item => ({
              testingName: item.name,
              key: item.configKey
            }))
            // 初始化移动端数据
            this.testingData.forEach((item, index) => {
              this.$set(this.mobileParams, index, { page: 0, size: 10 })
              this.$set(this.mobileTotal, index, 0)
            })
            
            if (this.testingData.length > 0) {
              if (this.isMobile) {
                this.getArticleList(this.testingData[0].key, 0)
              } else {
                this.onTestingName(this.testingData[0], 0)
              }
            }
          } else {
            this.testingData = []
          }
        }).catch(err => {
          console.error('Failed to get download center data:', err)
          this.testingData = []
        })        
    },
    // 获取检验能力列表数据
    getArticleList(key, index = null) {
      const params = index !== null 
        ? {
            page: this.mobileParams[index]?.page || 0,
            size: this.mobileParams[index]?.size || 10,
            key: key
          }
        : {
            page: this.params.page,
            size: this.params.size,
            key: key
          }

      getArticleList(params).then((res) => {
        // 移动端
        if (index !== null) {
          this.$set(this.mobileTotal, index, res.count)
          this.$set(this.mobileListData, index, res.list)
        } else {
          this.total = res.count
          this.listData = res.list
        }
      })
    },
    // 处理分页
    handlePagination(type, val, index = null) {
    if (index !== null) {
      // 移动端分页处理
      this.$set(this.mobileParams, index, {
        ...this.mobileParams[index],
        page: type === 'size' ? 0 : val - 1,
        size: type === 'size' ? val : this.mobileParams[index]?.size || 10
      })
      this.getArticleList(this.testingData[index].key, index)
    } else {
      // PC端分页处理
      this.params = {
        ...this.params,
        page: type === 'size' ? 0 : val - 1,
        size: type === 'size' ? val : this.params.size
      }
      this.getArticleList(this.testingData[this.isActiveI].key)
    }
  },
    toDetails(query, linkTo) {
      if (linkTo) {
        window.open(linkTo, '_blank')
      } else {
        this.$router.push({ path: '/details', query })
      }
    }
  },
  mounted() {
    if (this.$route.hash) {
      this.scrollToAnchor(this.$route.hash.slice(1))
    }
    // 是否移动端
    this.isMobile = window.innerWidth <= 768 

    this.getTestingData()
    if (this.testingData.length > 0) {
      this.getArticleList(this.testingData[0].key)
    }
  },
  created() {
    this.getArticleDetails()
  }
}
</script>

<style lang="scss" scoped>
.office-hall {
  width: 100%;
  flex: 1;
  .mytab {
    background: url(../../assets/images/tab_bg_2.webp) no-repeat;
    background-size: 100% 100%;
  }

  .service {
    width: 100%;
    flex-wrap: wrap;
    margin: 16px 0 40px;
    .guide {
      width: 220px;
      height: 60px;
      background: #f1f7fe;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4px 4px 4px 4px;
      margin-right: 24px;
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 400;
      font-size: 22px;
      color: #333333;
      text-align: center;
      font-style: normal;
      cursor: pointer;

      &:hover {
        background: #c2daf580;
        color: #14579e;
        font-weight: bold;
      }
    }
    .my-guide {
      width: 260px;
    }
    :nth-child(5n) {
      margin-right: 0;
    }
  }
  .in-disclosure {
    margin-top: 40px;
    .card-box {
      width: 100%;
      margin: 16px 0 40px;
      div {
        width: 278px;
        height: 240px;
        background: #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
        padding: 26px;
        img {
          width: 71px;
        }
        b {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          margin: 18px 0 9px;
        }
        .box-span {
          color: #333333;
          text-align: center;
        }
      }
    }
  }

  .carousel-tab {
    margin-bottom: 40px;
    .tab {
      margin-bottom: 16px;
    }
    .slideshow {
      overflow: hidden;

      .el-carousel__indicator.is-active button {
        background-color: #1b6ad2;
      }

      .el-carousel__indicators {
        margin: 0 auto;
        padding-bottom: 0 !important;
      }
      ::v-deep .el-carousel__indicator--horizontal {
        padding: 0px !important;
      }

      .el-carousel__button {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #1b6ad260;
        background-color: #1b6ad260;
        border: none;
      }
    }
    .carousel-image-box {
      overflow: auto;
      height: 100%;
    }

    .testing-ability {
      height: 580px;
    }
    .content {
      width: 100%;
      background: url(../../assets/images/back.webp) no-repeat;
      background-size: 100% 100%;
      padding: 20px 0 20px;
      .left {
        height: 100%;
        overflow: auto;
        min-width: 246px;
      }
      .left-title {
        height: 45px;
        width: 217px;
        background: #e4edfa;
        margin-bottom: 2px;
        text-align: center;
        font-weight: 400;
        font-size: 18px;
        color: #1e1e1e;
        cursor: pointer;
        position: relative;
        padding: 0 12px;
      }
      .is-active {
        background: #1b6ad2;
        color: #fff;
      }
      .is-active::after {
        content: '';
        height: 45px;
        position: absolute;
        display: block;
        top: 0;
        right: -23px;
        width: 0px;
        height: 0px;
        border-top: 23px solid transparent; /* 上边框 */
        border-bottom: 22px solid transparent; /* 下边框 */
        border-left: 23px solid #1b6ad2; /* 左边框，设置颜色和宽度 */
        z-index: 4;
      }
      .right {
        width: 100%;
        margin: 45px 26px 45px 20px;
        overflow: auto;
        
         .news-ul-li {
            background: none;
            overflow-y: scroll;
            padding: 0px 40px 20px;
            margin-bottom: 16px;

            li {
              min-height: 47px;
              border-bottom: 1px solid #14579e;

              &:hover {
                p {
                  color: #14579e;
                  font-weight: 600;
                  transform: scale(1.01);
                }
                span {
                  font-weight: normal;
                }
              }
              
              p {
                font-size: 18px;
                color: #131414;
                line-height: 40px;
              }

              span {
                font-size: 18px;
                line-height: 40px;
                width: 116px;
                display: inline-block;
                font-weight: normal;
              }
            }
        }
      }
    }
  }

  ::v-deep .el-collapse-item__header {
    height: 32px;
    background-color: #e4edfa;
    padding-left: 16px;
    font-size: 14px;
    border-radius: 4px;
  }
  ::v-deep .el-collapse-item {
    margin-top: 16px;
  }
  ::v-deep .el-collapse-item__content {
    font-size: 14px;
    padding: 16px;
  }
  ::v-deep .el-collapse-item__header.is-active {
    font-weight: bold;
    font-size: 14px;
    color: #1b6ad2;
    line-height: 22px;
  }
  ::v-deep .el-collapse-item__arrow {
    margin-right: 16px;
  }
  ::v-deep .el-icon-arrow-right:before {
    content: '\25b2';
    font-size: 14px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(180deg);
  }
}

@media screen and (max-width: 768px) {
  .office-hall {
    .service {
      margin: 16px 0 24px;
      .guide {
        width: calc((100% - 24px) / 2);
        font-size: 14px;
        margin-bottom: 16px;
      }
      :nth-child(2n) {
        margin-right: 0;
      }
    }

    .mobile-comp {
      .mytab {
        margin-bottom: 16px;
      }
      .carousel-image {
        width: 100%;
        height: auto;
      }
      .carousel-box {
        margin-bottom: 40px;
      }
    }
    .doc-box {
      background: #ffffff;
      padding-bottom: 16px;
    }
    .in-disclosure {
      margin-top: 40px;
      .card-box {
        flex-wrap: wrap;
        width: 100%;
        margin: 16px 0 26px;
        div {
          width: calc((100% - 24px) / 2);
          height: 200px;
          background: #ffffff;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
          padding: 16px;
          margin-bottom: 16px;
          img {
            width: 51px;
          }
          b {
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            margin: 18px 0 9px;
          }
          .box-span {
            color: #333333;
            text-align: center;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
